import type { CSSProperties } from 'react';

export const labeledCheckboxStyles: Record<string, CSSProperties> = {
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
  },
  box: {
    position: 'relative',
    width: 18,
    height: 18,
    flexShrink: 0,
    display: 'inline-flex',
  },
  // Matches the ~0.38 fade md-checkbox applied via `ng-disabled` on the
  // pre-migration Angular markup. Scoped to the box (input + check tick)
  // so the label text stays legible.
  boxDisabled: {
    opacity: 0.38,
  },
  input: {
    display: 'inline-block',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    boxSizing: 'border-box',
    width: 18,
    height: 18,
    padding: 0,
    margin: 0,
    borderRadius: 4,
    border: '1px solid currentColor',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  inputDisabled: {
    cursor: 'not-allowed',
  },
  check: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 18,
    height: 18,
    pointerEvents: 'none',
  },
  text: {
    margin: 0,
    fontSize: 12,
    lineHeight: '20px',
    whiteSpace: 'pre-line',
  },
  label: {
    margin: 0,
    cursor: 'pointer',
    padding: 0,
    position: 'static',
    fontSize: 12,
    lineHeight: '20px',
    fontFamily: 'inherit',
    color: 'inherit',
    letterSpacing: 'normal',
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: 12,
    lineHeight: '20px',
    color: 'inherit',
    fontWeight: 'bold',
  },
};
